import usePersistantState from "src/hooks/usePersistantState";
import CheckBox from "./CheckBox";
import { useEffect, useState } from "react";
import CatchyCheckbox from "../CatchyCheckbox/CatchyCheckbox";
import { ToastContainer, toast } from "react-toastify";

export default function GridingCheckboxSingle({ single, handleState, state, index, givenOptions, maxFive = 999, maxFour = 999 }) {

    let chosenType;



    chosenType = JSON.parse(JSON.stringify(givenOptions))

    let chosenTypeOption = JSON.parse(JSON.stringify(chosenType));
    Object.keys(chosenTypeOption).forEach(key => {
        chosenTypeOption[key] = false;
    })
    const [options, setOptions] = useState(chosenTypeOption)
    const [isFirst, setIsFirst] = useState(true)
    useEffect(() => {
        Object.keys(chosenType).forEach(key => {
            if (chosenType[key] == state[single].value && isFirst) {
                handleOptions(key)
                setIsFirst(false);
            }
        })
    }, [state])


    const handleOptions = (key) => {
        Object.keys(options).forEach(key => {
            if (options[key]) {
                options[key] = false;
            }
        });
        setOptions({
            ...options,
            [key]: !options[key],
        })
        let newOption = {
            ...options,
            [key]: !options[key],
        }
        handleState({
            ...state,
            [single]: {
                value: chosenType[key],
                desc: state[single].desc
            }
        })

    }

    const salam = (key) => {
        let FiveCount = 0;
        let FourCount = 0;
        Object.values(state).forEach(single => {
            if (single.value == 5) {
                ++FiveCount;
            }
            if (single.value == 4) {
                ++FourCount;
            }
        });
        if (FiveCount >= maxFive && key == Object.keys(chosenType)[5]) {
            toast.error(`شما حداکثر می‌توانید ${maxFive} مورد ${Object.keys(chosenType)[5]} انتخاب کنید`);
        } else if (FourCount >= maxFour && key == Object.keys(chosenType)[4]) {
            toast.error(`شما حداکثر می‌توانید ${maxFour} مورد ${Object.keys(chosenType)[4]} انتخاب کنید`);
        } else {
            handleOptions(key)
        }
    }

    const handleInputChange = (e) => {
        let newState = {
            ...state,
        }
        delete newState[Object.keys(newState)[index]];
        newState[e.target.value] = {
            value: null,
            desc: "",
        }
        handleState(newState);
    }
    const optionsJSX = Object.keys(options).map((key, index) => (<CatchyCheckbox type={2} key={index} label={key} data={options} handleCheck={() => salam(key)} />));

    return (
        <>

            <div className="mt-8 flex flex-col">
                <div className="w-full flex justify-center items-center border border-solid border-gray-400 p-2">

                    <div>
                        <span className="font-bold text-gray-700">
                            {single} ‌ ‌
                        </span>
                        <span className="text-[13px] text-[#7A7A7A]">
                            {state[single].desc}
                        </span>
                    </div>


                </div>
                <div className="text-[14px] text-[#7A7A7A] flex flex-row justify-between items-stretch">
                    {optionsJSX}
                </div>
            </div>
        </>
    )
}